import { useSelector } from 'react-redux';
import { getReservationType } from 'utils/helpers/reservations';
import useIsLoggedIn from 'utils/hooks/use_is_logged_in';
import { getNextUpcomingReservation } from 'redux/selectors/current_booking';
import Accommodation from './accommodation';
import Experience from './experience';
import FerryOrTransfer from './ferry_or_transfer';

const UpcomingBooking = () => {
  const upcomingReservation = useSelector(getNextUpcomingReservation);
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn || !upcomingReservation) {
    return null;
  }

  const reservationType = getReservationType(upcomingReservation);

  if (['ferry', 'transfer'].includes(reservationType)) {
    return <FerryOrTransfer />;
  }

  if (reservationType === 'experience') {
    return <Experience />;
  }

  if (reservationType === 'accommodation') {
    return <Accommodation />;
  }

  return null;
};

export default UpcomingBooking;
